import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledWrapper = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});

export const StyledChartContainer = styled(Box)({
  flex: "1 1 100%",
  minHeight: 0,
  width: "100%",
  overflow: "hidden",
  position: "relative",
  contain: "size layout",
});
